import { join, pathOr } from 'ramda';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Button from 'src/components/Buttons/Button';
import makeStyles from '@mui/styles/makeStyles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Theme } from '@mui/material/styles/createTheme';
import ChevronLeftIcon from 'src/assets/icons/chevron-left.svg';
import AddressFields from 'src/components/AddressDropdown/AddressFields';
import { getTheme } from 'src/utilities/siteSettings';
const theme = getTheme();

const useMenuStyles = makeStyles((theme: Theme) => ({
  goBackBtn: {
    top: 16,
    left: 10,
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'flex-start',
      left: 0,
      top: 18,
    },
  },
  dialogTitle: {
    textAlign: 'center',
    fontFamily: 'Martel,serif',
  },
  dialogHeader: {
    borderTop: '1px solid #EEE',
  },
}));
interface Props {
  open: any;
  toggleClose: () => void;
  handleSetAddress: (e: any, suit: any,county?:any) => void;
  formattedAddress: any;
  suite: any;
  setSuite?:(suite:string)=>void;
}
type CombinedProps = Props;
const AddressModal: React.FC<CombinedProps> = (props: CombinedProps) => {
  const classes = useMenuStyles();
  const { open, toggleClose, formattedAddress, suite, handleSetAddress, setSuite } = props;
  const { street, city, state, zipcode,county } = formattedAddress;

  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    getValues
  } = useForm({
    defaultValues: {
      street: '',
      city: '',
      state: '',
      zipcode: '',
      suit: '',
      county:''
    },
  });

  useEffect(() => {
    setValue('street', street);
    setValue('city', city);
    setValue('state', state);
    setValue('zipcode', zipcode);
    setValue('suit', suite);
    setValue('county', county);
  }, [formattedAddress]);
 
 
  const handleSave = () => {
    const buildAddressString = join(', ', [
      pathOr('', ['street'], getValues()),
      pathOr('', ['city'], getValues()),
      pathOr('', ['state'], getValues()),
      pathOr('', ['zipcode'], getValues()),
    ]);
    handleSetAddress(buildAddressString, pathOr('', ['suit'], getValues()), pathOr('', ['county'], getValues()));
  };

  const { breakpoints } = useTheme();
  const matches = useMediaQuery(breakpoints.down('sm'));
  return (
    <Dialog open={open} onClose={toggleClose} maxWidth="md" fullWidth>
      <Box className={classes.dialogHeader}>
        <DialogTitle className={classes.dialogTitle}>
          Confirm Address
        </DialogTitle>

        <Button
          px={30}
          py={6}
          text={matches ? '' : 'Go back'}
          variant="text"
          onClick={toggleClose}
          startIcon={
            <ChevronLeftIcon color={theme.palette.primaryColor.main} />
          }
          className={classes.goBackBtn}
        />
      </Box>

      <form onSubmit={handleSubmit(handleSave)}>
        <DialogContent>
          <AddressFields
            control={control}
            errors={errors}
            setSuite={setSuite}
          />
        </DialogContent>
        <DialogActions>
          <Button
            px={40}
            variant="outlined"
            onClick={toggleClose}
            text="Cancel"
          />
          <Button px={40} ml={1} text="Save" type='submit' />
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddressModal;
